import makeStyles from '@mui/styles/makeStyles';
import { Box, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import React from 'react';
import {
  PayRateFormProps,
  Tier2DeliveryPay,
} from '../../../interfaces/PayRate';
import { generateNumberInput } from '../../../utilities/PayRates';

export const Tier2DeliveryPayForm = (props: PayRateFormProps) => {
  const classes = useStyles();

  const tier2DeliveryPay = props.currentState as Tier2DeliveryPay;

  return (
    <Box component='div' className={classes.formWrapper}>
      <Box className={classes.row}>
        <Box component='div' className={classes.numberField}>
          {generateNumberInput<Tier2DeliveryPay>(
            true,
            true,
            tier2DeliveryPay,
            props.setter,
            'nonStarbucks',
            props.isDisabled,
            'Non Starbucks Amount',
          )}
        </Box>
        <Box component='div' className={classes.numberField}>
          {generateNumberInput<Tier2DeliveryPay>(
            true,
            true,
            tier2DeliveryPay,
            props.setter,
            'hotStarbucks',
            props.isDisabled,
            'Hot Starbucks Amount',
          )}
        </Box>
      </Box>
      <Box className={classes.row}>
        <Box component='div' className={classes.numberField}>
          {generateNumberInput<Tier2DeliveryPay>(
            true,
            true,
            tier2DeliveryPay,
            props.setter,
            'coldStarbucks',
            props.isDisabled,
            'Cold Starbucks Amount',
          )}
        </Box>
        <Box component='div' className={classes.numberField}>
          {generateNumberInput<Tier2DeliveryPay>(
            true,
            true,
            tier2DeliveryPay,
            props.setter,
            'standardStarbucks',
            props.isDisabled,
            'Standard Starbucks Amount',
          )}
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formWrapper: {
      marginTop: theme.spacing(2),
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
    },
    row: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'row',
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
    },
    numberField: {
      width: 200,
      marginRight: theme.spacing(2),
    },
    isStarbucksSwitch: {
      marginLeft: theme.spacing(1.5),
    },
  }),
);
